import Swal from "sweetalert2";
import {
  ADDALLJOB,
  GETALLAPPLIED,
  GETALLCANDIDATE,
  GETALLJOB,
  GETALLJOBWITHCANDIDATEAPPLIED,
  UPDATEALLJOB,
} from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";

export const getAllJob = async (payload, callback) => {
  await axios
    .post(GETALLJOBWITHCANDIDATEAPPLIED, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const jobPostAdd = async (payload, callback) => {
  await axios
    .post(ADDALLJOB, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully Added",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const jobPostUpdate = async (payload, callback) => {
  await axios
    .post(UPDATEALLJOB, payload)
    .then((res) => {
      callback(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Successfully updated",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getAllApplied = async (payload, callback) => {
  await axios
    .post(GETALLAPPLIED, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const getAllCandidate = async (payload, callback) => {
  await axios
    .post(GETALLCANDIDATE, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};
